// @flow

import styled, { css } from "styled-components";
import buildColor from "@fdr/static-ui/ColorPalette";
import Button from "../../_atoms/Button";
import DefaultButton from "../../_atoms/ButtonDefault";

export const PaginationWrapper = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${(props) => {
    let returnCSS = "";
    switch (props.theme) {
      case "tutorials":
        returnCSS = css`
          margin-top: 22px;

          & > button {
            min-width: 60px;
            text-transform: uppercase;
            background-color: ${buildColor("white", "00")};

            &:first-child {
              text-align: left;
            }

            svg {
              fill: ${buildColor("blue", "100")};
            }
          }
        `;
        break;
      case "topRaces":
        returnCSS = css`
          max-width: 64px;
          border: 1px solid ${buildColor("blue", "100")};
          background-color: ${buildColor("navy", "000")};
          border-radius: 4px;

          &:hover {
            cursor: pointer;
          }

          & > button {
            background-color: ${buildColor("white", "00")};
            width: 32px;
            height: 32px;
            padding: 8px;

            svg {
              fill: ${buildColor("navy", "500")};
            }

            &:hover {
              background-color: ${buildColor("navy", "100")};
            }
          }
        `;
        break;
      default:
        returnCSS = css`
          background-color: ${buildColor("white", "00")};
          padding: 8px;

          & > button {
            background-color: ${buildColor("white", "00")};
            width: 40px;
            height: 40px;

            &:first-child:active,
            :last-child:active {
              background-color: ${buildColor("blue", "000")};
            }
          }
        `;
        break;
    }
    return returnCSS;
  }};
`;

export const PaginationBullet = styled.span`
  background-color: ${(props) =>
    props.active ? buildColor("blue", "500") : buildColor("grey", "500")};
  width: 8px;
  height: 8px;
  border-radius: 50%;
  padding: 0;
  margin-right: 6px;
`;

export const PagesWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const ButtonPage = styled(Button)`
  width: 40px;
  height: 40px;

  & :not(:first-child) {
    margin-left: 8px;
  }
`;

export const TopRacesButtonDefault = styled(DefaultButton)`
  border: none;
  margin: 0;
`;

export const NextWrapper = styled.span`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  color: ${buildColor("blue", "100")};
  font-weight: bold;
`;

export const WordWrapper = styled.span`
  padding-right: 8px;
`;

export const NextBtnWrapper = styled.div`
  & > button {
    background-color: ${buildColor("blue", "500")};
    width: 72px;

    &:hover {
      background-color: ${buildColor("blue", "500")};
    }
  }
`;

export const PrevBtnWrapper = styled.div`
  & > button {
    background: none;
    border: none;
    width: 72px;
    padding: 0;
    justify-content: flex-start;

    &:hover {
      background: none;
    }

    & > svg {
      fill: ${buildColor("blue", "500")};
    }
  }
`;
